import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const OpportunityNoteInput = () => {
  const { noteId = '' } = useParams();
  const decodedId = noteId ? atob(noteId) : noteId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunityNotes';

  useEffect(() => {
    if (noteId) { setIsEditing(true); fetchDetails(); }
  }, [noteId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['opportunityNotes'] + id + '/', { headers });
      const d = response.data?.data ?? response.data;
      setFormData({
        ...d,
        opportunity: d.opportunity?.id ?? d.opportunity,
        author: d.author?.id ?? d.author,
      });
    } catch (error) { console.error('Error fetching Opportunity Note details:', error); }
  };

  const fields = [
    {
      name: 'opportunity', label: 'Opportunity', type: 'async-select',
      endpoint: API_ROUTES.opportunity,
      getOptionLabel: (o) => o.opportunity_name,
    },
    { name: 'content', label: 'Note', type: 'textarea' },
    {
      name: 'note_type', label: 'Note Type', type: 'select',
      options: [
        { value: 'general', label: 'General' },
        { value: 'important', label: 'Important' },
        { value: 'follow_up', label: 'Follow-up' },
        { value: 'action_item', label: 'Action Item' },
        { value: 'decision', label: 'Decision' },
      ],
    },
    { name: 'is_private', label: 'Private Note', type: 'checkbox' },
    { name: 'is_pinned', label: 'Pin Note', type: 'checkbox' },
    {
      name: 'author', label: 'Author', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Note' : 'Create Opportunity Note'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunityNoteInput;
